function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m310.254 6.022 6 6 6-6",
  "data-name": "Path 501",
  style: {
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinejoin: "round",
    strokeWidth: "1.3px"
  },
  transform: "translate(-304.254 3)"
}));
export default SvgIconArrow24;